<template lang="html">
  <div class="dashboard">
    <!-- <v-header :name="name" :isDashboard="!child" :onBack="true" @backClick="backToDashboard"></v-header> -->
    <v-header :name="name" isDashboard></v-header>
    <div class="container">
      <div class="left"> 
        <div class="item1">
          <v-salesData  v-if="show" :salesData="salesData" :salesDataBar="salesDataBar" ></v-salesData>
        </div>       
        <div class="item2">
          <v-table v-if="show" :salesDataRealTime="salesDataRealTime" ></v-table>
        </div>
      </div>
      <div class="center">
        <v-center :outputValue="outputValue" :productionScale="productionScale" ></v-center>
      </div>
      <div class="right">
        <div class="item">
          <v-generatingData></v-generatingData>
        </div>
           <div class="item">
          <v-harvestingPlan></v-harvestingPlan>
        </div>
           <div class="item">
          <v-planting></v-planting>
        </div>
      </div>
    </div>
      <!-- <div class="swiper-button-prev"  @click="prev"></div>
      <div class="swiper-button-next" @click="next"></div> -->
  </div>
</template>

<script>
import Swiper from 'swiper';
import header from 'components/common/header'
import salesData from './components/salesData'
import table from './components/table'
import planting from './components/planting'
import harvestingPlan from './components/harvestingPlan'
import generatingData from './components/generatingData'
import center from './components/center'
export default {
  data() {
    return {
      show: false,
      name: '智慧农业4.0',
      outputValue: '',
      productionScale: '',
      salesData: [],
      salesDataBar: [],
      salesDataRealTime: [],
      timerDashboard: null
    }
  },
  async  mounted() {
    // new Swiper('.swiper-container', {
    //   direction: 'horizontal', // 水平切换选项
    //   loop: true, // 循环模式选项
    //   autoplay: 3000,
    //   navigation: {
    //     nextl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev'
    //   }
    // })
    let { err, res } = await this.$model('dataManagement').commonfn2(this.$apiUrl.DATAANALYSIS.Agriculture);
    if (res.state === 200) {
      let resultData = JSON.parse(res.results)
      // console.log(resultData)
      this.outputValue = resultData.outputValue
      this.productionScale = resultData.productionScale
      this.salesData = resultData.salesData
      this.salesDataBar = resultData.salesDataBar
      this.salesDataRealTime = resultData.salesDataRealTime
      this.show = true
    } else {
      this.$message.showError(err);
    }
    // this.timerDashboard = setTimeout(() => {
    //   console.log("timerDashboard")
    //   this.next()
    // }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.timerDashboard);
    this.timerDashboard = null;
  },
  methods: {
    next() {
      this.$router.push('/rundaindustryInformation');
    },
    prev() {
      this.$router.push('/rundahelper');
    }

  },
  components: {
    'v-header': header,
    'v-salesData': salesData,
    'v-table': table,
    'v-harvestingPlan': harvestingPlan,
    'v-generatingData': generatingData,
    'v-center': center,
    'v-planting': planting
  }
}

</script>

<style lang="less" scoped>
html,
body {
  width: 100%;
  height: 100%;
  width: 100vw;
  height: 100vh;
  background-color: #060606;
}

.swiper-button-next {
  padding: -50px;
  position: absolute;
  z-index: 999;
  opacity: 1 !important;
  cursor: auto !important;
  pointer-events: auto !important;
}

.swiper-button-prev {
  opacity: 1 !important;
  cursor: auto !important;
  pointer-events: auto !important;
}

.dashboard {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background-size: 100% 100%;
}

.container {
  display: flex;
  width: 95%;
  height: 100%;
  margin: 0 auto;
  // border: 1px solid red;

  .center {
    width: 806/19.2vw;
    height: 80vh;
    margin: 0 auto;
    // margin-top: -4vh;
    // border: 1px solid yellow;
  }

  .left,
  .right {
    // border: 1px solid yellow;
    width: 500/19.2vw;
    height: 80%;
    .item {
      height: 25vh;
      margin-bottom: 1.5vh;
      // border: 1px solid red;
    }
    .item4 {
      height: 25vh;
    }
    .item1 {
      height: 53vh;
    }
    .item2 {
      height: 22vh;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?14648548